// @core/api/endpoints/secret/get_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SecretPolicyResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get access policy
 * Returns an access policy by name.
 */
export async function GetPolicy(
  policy_name: string,
  options?: RequestOptions
): Promise<SecretPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/policies/:policy_name`;
  requestPath = requestPath.replace(':policy_name', encodeURIComponent(policy_name));
  const requestOptions = options;
  return client.get<SecretPolicyResponse>(requestPath, { ...requestOptions });
}
